module.exports = __webpack_public_path__ + "img/aidt-logo.a3074853.jpg";